import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Versão 3.0.0
    </span>
    <div class="socials">
      <a href="#" target="_blank" class="ion ion-social-whatsapp"></a>
    </div>
  `,
})
export class FooterComponent {
}
